<template>
    <div class="Login">
        <div class="container">
            <h2>{{'Welcome Back' | language}}</h2>

            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <el-form :model="loginForm" status-icon ref="loginForm" label-width="120px" class="demo-ruleForm" :rules="$store.state.general.language === 'english' ? rules : rulesJp"
                        @submit.native.prevent
                        :label-position="labelPosition">

                        <el-alert v-if="error" :title="'Incorrect email address and / or password.' | language" type="error"
                        description="These credentials do not match our records." show-icon>
                        </el-alert>

                        <el-form-item prop="email">
                            <el-input v-model="loginForm.email" autocomplete="off" @keyup.enter.native="submitForm('loginForm')" placeholder="Email Address" prefix-icon="el-icon-message"></el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input type="password" v-model="loginForm.password" autocomplete="off" @keyup.enter.native="submitForm('loginForm')" placeholder="Password" prefix-icon="el-icon-lock"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button class="Login__Button" type="primary" @click="submitForm('loginForm')" :loading="loading">{{'Login' | language}}</el-button>
                        </el-form-item>
                        <el-form-item class="bottom-links">
                            <router-link to="/register" class="navigation navigation__navitem create-account">{{'Create an Account' | language}}</router-link>
                            <router-link to="/forgotten-password" class="navigation navigation__navitem forgot-password">{{'Forgot password' | language}}</router-link>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="col-sm-6 col-xs-12 features">
                    <div class="feature">
                        <i class="el-icon-star-off icon"></i>
                        <div class="feature-text">
                            <h5>{{"Don't miss a thing" | language}}</h5>
                            <p>{{'Save homes you loved and access them quickly' | language}}.</p>
                        </div>
                    </div>
                    <div class="feature">
                        <i class="el-icon-school icon"></i>
                        <div class="feature-text">
                            <h5>{{'Be up to date' | language}}</h5>
                            <p>{{'Receive special deals and updates on your favourite properties' | language}}.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'login',
        components: {
        },
        props: {},
        data: function () {
            return {
                labelPosition: 'top',
                loginForm: {
                    email: '',
                    password: '',
                },
                error: false,
                loading: false,
                rules: {
                    email: [
                        { required: true, message: 'Please input email address', trigger: 'blur' },
                        { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
                    ],
                    password: [
                        { message: 'password is required', required: true }
                    ]
                },
                rulesJp: {
                    email: [
                        { required: true, message: 'メールアドレスを入力してください', trigger: 'blur' },
                        { type: 'email', message: '正しいメールアドレスを入力してください', trigger: ['blur', 'change'] }
                    ],
                    password: [
                        { message: 'パスワードが必要です', required: true}
                    ]
                }
            }
        },

        created() {

        },
        methods: {
            submitForm(formName) {
                event.preventDefault()

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.error = false
                        this.loading = true
                        const params = {
                        email: this.loginForm.email,
                        password: this.loginForm.password
                    }
                    const promise = this.$store.dispatch('user/login', params);
                    promise
                        .then(() => {
                            this.$router.push('/');
                        })
                        .catch(() => {
                            this.error = true;
                        })
                        .finally(() => {
                            this.loading = false
                        })
                    } else {
                        return false;
                    }
                });
            }
        },
        head: {
            title: function() {
                return {
                    inner: 'Login'
                }
            },
            meta: [
                { name: 'title', content: 'Login to Japan Home Finder' },
                { name: 'keywords', content: 'japan home finder, japan realestate, apartment, house, for rent, for lease' },
                { name: 'description', content: 'Making your Japan home search easier' }
            ]
        }
    }
</script>

<style lang="scss" scoped>
    .Login {
        padding: 1em 0;

        form {
            max-width: 300px;
            margin-left: auto;

            .el-form-item {
                margin-top: 1em!important;

                &.is-error {
                    margin-bottom: 1.5em!important;
                }
            }

            .bottom-links {
                margin-top: .5em!important;
            }

            .navigation__navitem {
                padding: 0;
                color: $alternate-color;

                &.forgot-password {
                    float: right;
                }
            }
        }

        h2 {
            text-align: center;
        }

        &__Button {
            width: 100%;
        }

        .feature {
            display: flex;
            align-items: center;
            margin-top: 1.5em;
            padding-left: 2em;
            max-width: 420px;

            .icon {
                font-size: 2em;
                margin-right: .5em;
                color: rgba($alternate-color, .3);

                &.el-icon-house {
                    font-size: 1.5em;
                }
            }

            h5 {
                margin: 0;
            }

            p {
                margin: 0;
            }
        }

        @media (max-width: 767px) {
            form {
                margin: 0 auto;
            }

            .features {
                padding-top: 1em;
                border-top: 1px solid;
                max-width: 350px;
                margin: 1em auto 0 auto;
            }

            .feature {
                margin: 1em auto;
                padding: 0;
            }
        }
    }
</style>